import React, { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/logo.svg";
export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navLinks = [
    { to: "/", label: "Ana Sayfa" },
    { to: "/projects", label: "Projeler" },
    { to: "/about", label: "Hakkımızda" },
    { to: "/contact", label: "İletişim" },
  ];

  return (
    <header className={"navbar" + (scrolled ? " navbar--scrolled" : "")}>
      <div className="navbar__inner container">
        <Link to="/" className="navbar__logo">
          {/* <span className="navbar__logo-icon">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <rect width="32" height="32" rx="8" fill="var(--clr-primary)"/>
              <path d="M8 22 L16 10 L24 22" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="16" cy="10" r="2.5" fill="var(--clr-accent)"/>
              <path d="M11 18 L21 18" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.6"/>
            </svg>

          </span> */}
          <img src={logo} alt="Vincora" className="navbar__logo-img" />
          <span className="navbar__logo-text">
            Vincora <span>Robotics</span>
          </span>
        </Link>

        <nav className={"navbar__nav" + (menuOpen ? " navbar__nav--open" : "")}>
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === "/"}
              className={({ isActive }) =>
                "navbar__link" + (isActive ? " navbar__link--active" : "")
              }
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            className="btn btn-primary navbar__cta"
            onClick={() => setMenuOpen(false)}
          >
            Bize Ulaşın
          </Link>
        </nav>

        <button
          className={
            "navbar__burger" + (menuOpen ? " navbar__burger--open" : "")
          }
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menüyü aç/kapat"
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
}
